var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { request } from '@max/meituan-uni-network';
const isWeb = true;
import { isDianpingAppOrWebview, getPlatformType, PlatformType } from '@nibfe/mkt-env-api';
import { getUserInfo } from '@nibfe/mkt-user-api';
import { AntiReqTool } from '@nibfe/h5guard-request';
import { reportJSInfo } from '@max/meituan-uni-report';
export const AJAX_ERROR_NAME = '网络错误';
const API_MAP = {
    PROD: 'https://ihotel.meituan.com',
    TEST: 'https://api.hotel.test.meituan.com'
};
export var API_PATH_ENUM;
(function (API_PATH_ENUM) {
    // 查询活动信息
    API_PATH_ENUM["QUERY_LUCKY_PICKER_INFO"] = "/landing/page/remoteCity/queryTrainRemoteCity";
})(API_PATH_ENUM || (API_PATH_ENUM = {}));
const platform = getPlatformType();
const isPlatformDP = isDianpingAppOrWebview() || getPlatformType() === PlatformType.dpMinaWebview;
const isDp = [PlatformType.dpMinaWebview, PlatformType.dpAppWebView, PlatformType.dpApp].includes(platform);
var SourceEnum;
(function (SourceEnum) {
    SourceEnum[SourceEnum["mtApp"] = 1] = "mtApp";
    SourceEnum[SourceEnum["dpApp"] = 2] = "dpApp";
    SourceEnum[SourceEnum["mtMinaWebview"] = 3] = "mtMinaWebview";
    SourceEnum[SourceEnum["mtHotelMinaWebview"] = 4] = "mtHotelMinaWebview";
    SourceEnum[SourceEnum["mtDpMinaWebview"] = 5] = "mtDpMinaWebview";
})(SourceEnum || (SourceEnum = {}));
export const requestAroundCityInfo = (requestConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const path = API_PATH_ENUM.QUERY_LUCKY_PICKER_INFO;
    const { params } = requestConfig;
    const { locateCityId, locateCityName, queryStartCityId, queryStartCityName, runTimeEnd } = params;
    const res = (yield getUserInfo()) || {};
    const userId = (res === null || res === void 0 ? void 0 : res.userId) || "";
    const token = (res === null || res === void 0 ? void 0 : res.token) || "";
    let requestParams = {
        userId: userId === null || userId === void 0 ? void 0 : userId.toString(),
        token,
        platform: isDp ? 2 : 1,
        source: SourceEnum[(isPlatformDP ? 'dpApp' : platform)] || 1,
        locateCityId,
        locateCityName,
        queryStartCityId,
        queryStartCityName,
        runTimeEnd
    };
    if (true) {
        try {
            const antiReq = new AntiReqTool({
                autoFillParams: true
            });
            // @ts-ignore
            requestParams = antiReq.addCommonParams(requestParams);
        }
        catch (_a) {
            reportJSInfo({
                level: 'info',
                content: '请求加上反爬参数错误',
                secCategory: 'ajaxError'
            }).catch();
        }
    }
    return new Promise((resolve, reject) => {
        request({
            url: `${API_MAP.PROD}${path}`,
            data: requestParams,
            params: {
                isPtest: 'true'
            },
            method: 'POST',
            header: {
                'content-type': 'application/json'
            },
            _meituan: {
                requestType: 'MRNUtils',
                mrnChannel: 'hotel'
            },
            success(res) {
                var _a, _b;
                if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.status) === 0) {
                    const templateRes = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data;
                    resolve(templateRes);
                }
                else {
                    const error = new Error(AJAX_ERROR_NAME);
                    error.name = AJAX_ERROR_NAME;
                    error.message = '请求接口异常-status非0';
                    let tags = {};
                    try {
                        tags = {
                            response: JSON.stringify(res),
                            params: JSON.stringify(requestParams)
                        };
                    }
                    catch (e) { }
                    reportJSInfo({
                        secCategory: 'ajaxError',
                        level: 'info',
                        error,
                        tags
                    }).catch();
                    resolve({});
                }
            },
            fail(error) {
                if (typeof error === 'object') {
                    error.name = AJAX_ERROR_NAME;
                    error.message = '请求接口异常-网络异常';
                }
                let tags = {};
                try {
                    tags = {
                        errorInfo: JSON.stringify(error),
                        params: JSON.stringify(requestParams)
                    };
                }
                catch (e) { }
                reportJSInfo({
                    secCategory: 'ajaxError',
                    level: 'info',
                    error,
                    tags
                }).catch();
                resolve({});
            }
        });
    });
});
